/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import AggregatePrice from './cpns/AggregatePrice.vue';
import MortarPrice from './cpns/MortarPrice.vue';
export default defineComponent({
  name: 'SalePrice',
  components: {
    MortarPrice: MortarPrice,
    AggregatePrice: AggregatePrice
  },
  setup: function setup() {
    var tabIndex = ref(0);
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log(tabIndex, 111);
              tabIndex.value = val;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var componentArray = ref(['AggregatePrice', 'MortarPrice', 'MortarPrice']);
    var curTabComponent = computed(function () {
      return componentArray.value[tabIndex.value];
    });
    return {
      tabIndex: tabIndex,
      confirmType: confirmType,
      curTabComponent: curTabComponent
    };
  }
});